import Big from 'big.js';

Big.DP = 40;
Big.RM = Big.roundHalfUp;

const ZERO = new Big(0);

export const toBig = (value) => {
  if (value instanceof Big) return value;
  if (typeof value === 'bigint') return new Big(value.toString());
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return ZERO;
    return new Big(value);
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return ZERO;
    return new Big(trimmed);
  }
  if (value === null || value === undefined) return ZERO;
  return new Big(value);
};

export const add = (a, b) => toBig(a).plus(toBig(b)).toString();
export const subtract = (a, b) => toBig(a).minus(toBig(b)).toString();
export const multiply = (a, b, decimals = 18) => toBig(a).times(toBig(b)).toFixed(decimals, Big.roundHalfUp);
export const divide = (a, b, decimals = 18) => toBig(a).div(toBig(b)).toFixed(decimals, Big.roundHalfUp);

export const compare = (a, b) => toBig(a).cmp(toBig(b));
export const isZero = (value) => toBig(value).eq(ZERO);
export const isPositive = (value) => toBig(value).gt(ZERO);
export const isNegative = (value) => toBig(value).lt(ZERO);

export const max = (a, b) => (compare(a, b) >= 0 ? toBig(a).toString() : toBig(b).toString());
export const min = (a, b) => (compare(a, b) <= 0 ? toBig(a).toString() : toBig(b).toString());

export const toFixed = (value, decimals = 2) => toBig(value).toFixed(decimals, Big.roundHalfUp);

export const stripTrailingZeros = (value) => {
  const str = typeof value === 'string' ? value : toBig(value).toString();
  if (!str.includes('.')) return str;
  const [intPart, fracPartRaw] = str.split('.');
  let fracPart = fracPartRaw;
  while (fracPart.endsWith('0')) {
    fracPart = fracPart.slice(0, -1);
  }
  if (fracPart.length === 0) return intPart;
  return `${intPart}.${fracPart}`;
};

export const formatInputAmount = (value, decimals = 8) => {
  const fixed = toFixed(value, decimals);
  return stripTrailingZeros(fixed);
};

export const ensureString = (value) => (typeof value === 'string' ? value : toBig(value).toString());
